import { ARCHETYPES, ARCHETYPE_LABELS, type Archetype } from "../types/Game";

interface CategoryPillsProps {
	/** Currently selected archetype, or null for "All". */
	selected: Archetype | null;
	onChange: (archetype: Archetype | null) => void;
}

/**
 * Horizontally scrollable row of category filter chips. Used on the Browse
 * page. On mobile, the row scrolls; on desktop, pills wrap to multiple lines.
 */
export function CategoryPills({ selected, onChange }: CategoryPillsProps) {
	return (
		<div className="-mx-4 px-4 md:mx-0 md:px-0">
			<div className="flex md:flex-wrap gap-2 overflow-x-auto no-scrollbar pb-1">
				<Pill
					label="All"
					active={selected === null}
					onClick={() => onChange(null)}
				/>
				{ARCHETYPES.map((a) => (
					<Pill
						key={a}
						label={ARCHETYPE_LABELS[a]}
						active={selected === a}
						onClick={() => onChange(a)}
					/>
				))}
			</div>
		</div>
	);
}

function Pill({
	label,
	active,
	onClick,
}: {
	label: string;
	active: boolean;
	onClick: () => void;
}) {
	return (
		<button
			type="button"
			onClick={onClick}
			className={`shrink-0 px-4 h-9 rounded-full text-xs font-semibold uppercase tracking-wider transition-all duration-200 ${
				active
					? "bg-primary text-background shadow-[0_0_16px_rgba(0,255,136,0.4)]"
					: "bg-surface border border-border text-ink-muted hover:text-ink hover:border-primary/40"
			}`}
		>
			{label}
		</button>
	);
}
